/* eslint-disable import/prefer-default-export */
export const PLAYER_ACTION_TYPES = {
  FETCH_TEAM_PLAYERS_START: 'player/FETCH_TEAM_PLAYERS_START',
  FETCH_TEAM_PLAYERS_SUCCESS: 'player/FETCH_TEAM_PLAYERS_SUCCESS',
  FETCH_TEAM_PLAYERS_FAILURE: 'player/FETCH_TEAM_PLAYERS_FAILURE',
  FETCH_PLAYER_TROPHIES_START: 'player/FETCH_PLAYER_TROPHIES_START',
  FETCH_PLAYER_TROPHIES_SUCCESS: 'player/FETCH_PLAYER_TROPHIES_SUCCESS',
  FETCH_PLAYER_TROPHIES_FAILURE: 'player/FETCH_PLAYER_TROPHIES_FAILURE',
  SET_FILTERED_PLAYERS: 'player/SET_FILTERED_PLAYERS',
  RESET_STORE: 'player/RESET_STORE',
};
